'use client';

import ExchangeSection4 from '@enlighten/landing/dist/exchange/@section4';

export default function Section4() {
	return (
		<ExchangeSection4
			onClickLink={() => {
				window.open('https://der.kmos.kr', '_blank');
			}}
		/>
	);
}
